/* eslint-disable react/iframe-missing-sandbox */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable prefer-destructuring */
/* eslint-disable guard-for-in */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-duplicate-imports */
import React, { ChangeEvent, useCallback, useEffect, useMemo, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  Box,
  Grid,
  Dialog,
  Typography,
  IconButton,
  Autocomplete,
  DialogActions,
  DialogContent,
  FormHelperText
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { AtomicBlockUtils, ContentState, EditorState, Modifier, convertToRaw } from 'draft-js';
import _ from 'lodash';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import '../../../../../../assets/style/sass/richEditor.scss';
import { Controller, FieldValues, SubmitHandler, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import { API } from '../../../../../../api/index';
import upload from '../../../../../../assets/images/upload.svg';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import { articleActions, fetchAllArticles } from '../../../../../../redux/slices/article/getAllArticleSlice';
import draftToHtml from 'draftjs-to-html';
import { Close } from '@mui/icons-material';
import htmlToDraft from 'html-to-draftjs';
import { FileOutlined } from '@ant-design/icons';
import { FituredImage } from '../../../chat/ChatEditorComponent';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import { UiInput, UiSelect } from '../../../../../../components/ui/atoms';
import { GroupBasedRoleFormatter, handleImageCompression, imageSizeLimit, roleNameFormatter } from '../../../../components/common';
import CommonModalHeader from '../../../../../../components/DialogUi/CommonModalHeader';

const imgSize = imageSizeLimit();
const acceptedImages = 'image/jpeg,image/jpg,image/png';
const toolBarStyle = {
  border: 'none',
  backgroundColor: '#000000',
  color: '#FDFDFD',
  padding: '10px 0',
  marginBottom: 0,
  borderBottomLeftRadius: '6px',
  borderBottomRightRadius: '6px'
};

export const ImageBlock = ({ block, contentState, blockProps }: { block: any; contentState: any; blockProps: any }) => {
  const entityKey = block.getEntityAt(0);
  const { setEditorState } = blockProps.blockProps;
  const entity = entityKey !== null ? contentState.getEntity(entityKey) : null;
  const removeBlock = () => {
    const { editorState } = blockProps.blockProps;
    const selectionState = editorState.getSelection();
    const blockKey = block.getKey();
    const blockSelection = selectionState.merge({
      anchorKey: blockKey,
      focusKey: blockKey,
      anchorOffset: 0,
      focusOffset: block.getLength()
    });

    const updatedContentState = Modifier.removeRange(contentState, blockSelection, 'backward');

    // Update the editorState with the modified contentState
    const newEditorState = EditorState.push(editorState, updatedContentState, 'remove-range');

    setEditorState(newEditorState);
  };

  return (
    <div className="image-block">
      {entityKey !== null ? (
        <>
          {entity.getType() === 'IMAGE' ? (
            <img src={entity.getData().src} alt="Inserted content" style={{ maxWidth: '400px' }} />
          ) : (
            <iframe src={entity.getData().src} title="Inserted content" width={'300px'} height={'300px'} />
          )}
          <button onClick={removeBlock}>X</button>
        </>
      ) : null}
    </div>
  );
};

const IframeBlock = ({ block, blockProps }: { block: any; blockProps: any }) => {
  const entityKey = block.getEntityAt(0);
  const { setEditorState } = blockProps.blockProps;

  const removeBlock = () => {
    const { editorState } = blockProps.blockProps;
    const selectionState = editorState.getSelection();
    const blockKey = block.getKey();
    const blockSelection = selectionState.merge({
      anchorKey: blockKey,
      focusKey: blockKey,
      anchorOffset: 0,
      focusOffset: block.getLength()
    });

    const updatedContentState = Modifier.removeRange(editorState.getCurrentContent(), blockSelection, 'backward');

    // Update the editorState with the modified contentState
    const newEditorState = EditorState.push(editorState, updatedContentState, 'remove-range');

    setEditorState(newEditorState);
  };

  const contentState = blockProps.editorState.getCurrentContent(); // Get the current contentState

  return (
    <div className="iframe-block">
      {entityKey !== null ? (
        <>
          <iframe src={contentState.getEntity(entityKey).getData().src} title="Embedded Content" />
          <button onClick={removeBlock}>X</button>
        </>
      ) : null}
    </div>
  );
};

interface Props { }

export interface Article {
  articleId: string;
  orgId: string;
  groups: string[];
  articleName: string;
  type: string;
  coverImageUrl: string;
  fileUrl: string;
  authorName: string;
  authorId: string;
  createdBy?: string;
  readTime: string;
  accessFor: string;
  articleViewableTo: string;
  articleViewableUserType: string[];
  tags: string[];
  industries: string[];
  articleDescription: string;
  embeddedLinks: string;
  approved: boolean;
  upVotes: number;
  downVotes: number;
  views: number;
  isPublished: boolean;
  allowedGroup: boolean;
  __v: number;
  createdAt: number;
  location?: string;
}

const schema = yup.object().shape({
  articleName: yup.string().required('Article name is required'),
  type: yup.string().required('Article type is required'),
  readTime: yup.string().required('Read time is required'),
  authorName: yup.string().required('Author Name is required'),
  // accessFor: yup.string().required('Who Can View is required'),
  articleViewableTo: yup
    .string()
    .required('Who can view is required')
    .test(
      'helpful-tip-viewability',
      'Getting Started cannot be viewable to All of Dosen or Organization-wide',
      function (value) {
        const { topic } = this.parent;
        if (
          (topic === 'Helpful Tip' ||
            (Array.isArray(topic) && topic.includes('Helpful Tip'))) &&
          (value === 'All of Dosen' || value === 'Organization-wide')
        ) {
          return false;
        }
        return true;
      }
    ),

  articleViewableUserType: yup
    .array()
    .of(yup.string())
    .min(1, 'Which members can access is required')
    .required('Which members can access is required')
    .test(
      'helpful-tip-user-type',
      'Getting Started cannot be accessible to Admin or All members',
      function (value = []) {
        const { topic } = this.parent;
        if (
          (topic === 'Helpful Tip' ||
            (Array.isArray(topic) && topic.includes('Helpful Tip'))) &&
          (value.includes('admin') || value.includes('All members'))
        ) {
          return false;
        }
        return true;
      }
    ),
  topic: yup.string().required('Select a topic'),
  articleDescription: yup.string().required('Article Description is required'),
  coverImg: yup.mixed().required('Cover image is required')
});

interface Props {
  openForm: boolean;
  handleClickCloseForm: any;
  setOpenForm: any;
  selectedActiveId: any;
  singleListData: any;
  action: any;
  setAction: any;
}

const HelpEdit = ({
  openForm,
  handleClickCloseForm,
  setOpenForm,
  selectedActiveId,
  singleListData,
  action,
  setAction
}: Props) => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const grpId = params.id || '';
  const orgId = params.orgId || '';
  const [articleId] = useState<string>(selectedActiveId);
  const [isPublished, setIsPublished] = useState(true); // default set to true
  const [editCoverImg, setEditCoverImg] = useState<string>();
  const [type, setType] = useState('');
  const [readTimeValue, setReadTimeValue] = useState('');
  const [coverImageUrl, setCoverImageUrl] = useState<File | null>(null);
  const [addArticlesLoader, setAddArticlesLoaer] = useState(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [videoFile, setVideoFile] = useState<File | null>(null);
  const [videoError, setVideoError] = useState<string | null>(null);
  const [editVideoUrl, setEditVideoUrl] = useState<File | null>(null);
  const [audioFile, setAudioFile] = useState<any>(null);
  const [textFile, setTextFile] = useState<any>(null);
  const [defaultAudioUrl, setDefaultAudioUrl] = useState<any>('');
  const [defaultVideoUrl, setDefaultVideoUrl] = useState<any>('');
  const [audioError, setAudioError] = useState<string | null>(null);
  const [textFileError, setTextFileError] = useState<string | null>(null);
  const [editAudioUrl, setEditAudioUrl] = useState<File | null>(null);
  // const [error, setError] = useState('');
  const [imgError, setImgError] = useState('');

  const TagList = ['General', 'Product Tutorials', 'Case Studies', 'Testimonials', 'Program Materials', 'Helpful Tip'];

  const [audioUrl, setAudioUrl] = useState<any>(null);
  const [textFileUrl, setTextFileUrl] = useState<any>(null);
  const [videoUrl, setVideoUrl] = useState<any>(null);
  const [videoSource, setVideoSource] = useState<any>(null);
  const [editEmbedded, setEmbedded] = useState<boolean>(false);
  const blobTextFileUrl = textFile ? URL.createObjectURL(textFile) : null;
  const roleOptions = ['mentee', 'mentor', 'admin', 'All members'];
  const mentorRoleText = GroupBasedRoleFormatter('mentor', 'Mentor');
  const menteeRoleText = GroupBasedRoleFormatter('mentee', 'Mentee');
  // const [openFilter, setopenFilter] = useState(false);
  // const handleopenFilter = (flag: boolean) => setopenFilter(flag);

  useEffect(() => {
    setType('');
    setReadTimeValue('');
  }, []);

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    clearErrors,
    reset,
    watch,
    setError
  } = useForm({
    resolver: yupResolver(schema)
  });

  const validateTopicAndViewability = () => {
    const topic = getValues('topic');
    const articleViewableTo = getValues('articleViewableTo');
    const articleViewableUserType = getValues('articleViewableUserType');
    const topicArray = Array.isArray(topic)
      ? topic
      : (topic ? [topic] : []);
    const isHelpfulTip = topicArray.some((t: string) => t === 'Helpful Tip');
    if (
      isHelpfulTip &&
      (articleViewableTo === 'All of Dosen' || articleViewableTo === 'Organization-wide')
    ) {
      setError('articleViewableTo', {
        type: 'manual',
        message: 'Getting Started cannot be viewable to All of Dosen or Organization-wide'
      });
    } else {
      clearErrors('articleViewableTo');
    }

    if (
      isHelpfulTip &&
      (articleViewableUserType.includes('admin') || articleViewableUserType.includes('All members') || articleViewableUserType.includes('All'))
    ) {
      setError('articleViewableUserType', {
        type: 'manual',
        message: 'Getting Started cannot be accessible to Admin or All members'
      });
    } else {
      clearErrors('articleViewableUserType');
    }
  };

  useEffect(() => {
    validateTopicAndViewability();
  }, [
    JSON.stringify(getValues('topic')),
    getValues('articleViewableTo'),
    getValues('articleViewableUserType')
  ]);

  const watchArticleType = watch('type');
  const checkError = (fieldName: string) => Boolean(errors[fieldName]);
  const getError = (fieldName: string) => errors[fieldName]?.message;
  const [urlName, setUrlName] = useState('');

  let filename = urlName.substring(urlName.lastIndexOf('/') + 1);
  filename = filename.split('.')[0];
  filename = filename.replace(/^\d+_/, '');
  filename = filename.replace(/%20/g, ' ');
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      if (file.size > 100 * 1024 * 1024) {
        setVideoError('File size is too large. Maximum allowed size is 100MB.');
      } else {
        setVideoFile(file);
        setVideoError(null);
      }
    } else {
      setVideoFile(null);
      setVideoError('Video file is required for Video type.');
    }
  };
  const handleAudioFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      if (file.size > 100 * 1024 * 1024) {
        setAudioError('File size is too large. Maximum allowed size is 100MB.');
      } else {
        setAudioFile(file);
        setAudioError(null);
      }
    } else {
      setAudioFile(null);
      setAudioError('Audio file is required for Audio type.');
    }
  };

  const handleTextFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const targetFile: any = e.target.files && e.target.files[0];

    if (targetFile) {
      const fileExtension = targetFile.name.split('.').pop(); // Extract the file extension

      const file = new File(
        [targetFile],
        watch('articleName') ? watch('articleName') + `.${fileExtension}` : `attachment.${fileExtension}`,
        {
          type: targetFile.type
        }
      );

      if (file) {
        if (file.size > 100 * 1024 * 1024) {
          setTextFileError('File size is too large. Maximum allowed size is 100MB.');
        } else {
          if (fileExtension === 'pdf' || fileExtension === 'csv') {
            setTextFile(file);
          } else {
            setTextFileError('Unsupported file type. Please upload a PDF or CSV file.');
          }

          setTextFileError(null);
        }
      } else {
        setTextFile(null);
        setTextFileError('Audio file is required for Audio type.');
      }
    } else {
      setTextFile(null);
      setTextFileError('No file selected.');
    }
  };

  const validateAudioUrl = (url: string) => {
    const audioExtensions = ['.mp3', '.wav', '.ogg'];
    const isValidAudioUrl = audioExtensions.some((extension) => url.endsWith(extension));
    return isValidAudioUrl;
  };

  const [youtubeUrl, setYoutubeUrl] = useState<boolean>();

  const validateVideoUrl = (url: string) => {
    // const regularUrlRegex = /^(https?:\/\/)?(www\.)?youtube\.com\/watch\?v=[\w-]{11}$/;
    const regularUrlRegex = /^(https?:\/\/)?(www\.)?youtube\.com\/.*[?&]v=[\w-]{11}$/;

    // Regular expression for a youtu.be URL
    const shortUrlRegex = /^(https?:\/\/)?(www\.)?youtu\.be\/[\w-]{11}(\?[\w=&-]+)?$/;

    const reg = regularUrlRegex.test(url);
    const short = shortUrlRegex.test(url);

    const regAndShort = regularUrlRegex.test(url) || shortUrlRegex.test(url);

    setYoutubeUrl(regAndShort);

    const videoExtensions = ['.mp4', '.MOV', '.WMV', '.WEBM', '.webm'];
    const isValidVideoUrl = videoExtensions.some((extension) => url.endsWith(extension));

    return isValidVideoUrl || regAndShort;
  };

  useEffect(() => {
    const delay = 500;
    const timeoutId = setTimeout(() => {
      if (defaultAudioUrl) {
        if (validateAudioUrl(defaultAudioUrl)) {
          setAudioUrl(defaultAudioUrl);
          // setAudioUrlError(null);
        } else {
          // setAudioUrlError('Invalid audio URL');
        }
      } else {
        setAudioUrl('');
        // setAudioUrlError(null);
      }
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [defaultAudioUrl]);

  const [youtubeVideoUrlTest, setYoutubeVideoUrlTest] = useState('');

  useEffect(() => {
    const delay = 100;
    const timeoutId = setTimeout(() => {
      if (defaultVideoUrl) {
        if (validateVideoUrl(defaultVideoUrl)) {
          setVideoUrl(defaultVideoUrl);
          setYoutubeVideoUrlTest(defaultVideoUrl);
          // setAudioUrlError(null);
        } else {
          // setAudioUrlError('Invalid audio URL');
        }
      } else {
        setVideoUrl('');
        // setAudioUrlError(null);
      }
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [defaultVideoUrl]);

  const handleAudioUrlChange = (e: ChangeEvent<HTMLInputElement>) => {
    const url = e.target.value;
    setDefaultAudioUrl(url);
  };

  const handleVideoUrlChange = (e: ChangeEvent<HTMLInputElement>) => {
    const url = e.target.value;

    // Check if it's a youtu.be URL
    const youtuBeMatch = url.match(/youtu\.be\/([^?]+)/);
    if (youtuBeMatch) {
      const videoId = youtuBeMatch[1];
      // Construct the embed URL for youtu.be format
      setDefaultVideoUrl(`https://www.youtube.com/embed/${videoId}`);
      setVideoUrl(`https://www.youtube.com/embed/${videoId}`);
      return;
    }

    // Check if it's a regular YouTube URL
    const regularUrlMatch = url.match(/[?&]v=([^&]+)/);
    if (regularUrlMatch) {
      const videoId = regularUrlMatch[1];
      // Construct the embed URL for regular YouTube URL
      setDefaultVideoUrl(`https://www.youtube.com/embed/${videoId}`);
      setVideoUrl(`https://www.youtube.com/embed/${videoId}`);
      return;
    }

    // If it's neither youtu.be nor regular YouTube URL, set the default video URL
    setDefaultVideoUrl(url);
  };

  const insertImage = (editorState: EditorState, imageUrl: string, altImage: string) => {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity('IMAGE', 'IMMUTABLE', { src: imageUrl, alt: altImage });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

    const newEditorState = AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');

    return newEditorState;
  };

  const handlePaste = useCallback(
    (event: ClipboardEvent) => {
      const items = event.clipboardData?.items;
      if (!items) return;

      for (const item of items) {
        if (item.type.indexOf('image') === 0) {
          const file = item.getAsFile();
          if (file) {
            imageUpload(file, 400, 400, 0.5)
              .then((response: any) => {
                if (response.data.link) {
                  const imageUrl = response.data.link;
                  const altImage = 'image';
                  const width = '400px';
                  // Insert the uploaded image into the editor
                  const newEditorState = insertImage(editorState, imageUrl, altImage);
                  setEditorState(newEditorState);
                  // Prevent the default paste behavior
                  event.preventDefault();
                  return;
                }
              })
              .catch((error: any) => {
                console.error('Image upload error:', error);
              });
          }
        }
      }
    },
    [editorState]
  );

  useEffect(() => {
    const editorContainer = document.querySelector('.editorClassName');
    if (editorContainer) {
      editorContainer.addEventListener('paste', handlePaste as any);
    }

    return () => {
      if (editorContainer) {
        editorContainer.removeEventListener('paste', handlePaste as any);
      }
    };
  }, [handlePaste]);

  const blockRender = (contentBlock: any) => {
    const entityKey = contentBlock.getEntityAt(0);
    const contentState = editorState.getCurrentContent();

    if (contentBlock.getType() === 'atomic' || contentBlock.text === '📷') {
      return {
        component: ImageBlock,
        editable: false,
        props: {
          block: contentBlock,
          // contentState,
          blockProps: {
            editorState,
            setEditorState
          }
        }
      };
    }
    return null;
  };

  const findImageEntities = (contentBlock: any, callback: any, contentState: any) => {
    contentBlock.findEntityRanges((character: any) => {
      const entityKey = character.getEntity();
      return entityKey !== null && contentState.getEntity(entityKey).getType() === 'IMAGE';
    }, callback);
  };

  const decorator = [{ strategy: findImageEntities, component: FituredImage }];

  const handleCloseArticleForm = () => {
    setOpenForm(false);
    reset();
    setCoverImageUrl(null);
    setVideoFile(null);
    setEditAudioUrl(null);
    setAudioUrl(null);
    setDefaultAudioUrl(null);
    setDefaultVideoUrl(null);
    setVideoUrl(null);
    setEditCoverImg('');
    setEmbedded(false);
    setTextFile(null);
    setTextFileUrl(null);
    setImgError('');
    setIsPublished(true);
  };

  const handleEditorStateChange = (editorState: EditorState) => {
    setEditorState(editorState);
    const contentState = editorState.getCurrentContent();
    const blockMap = contentState.getBlockMap();
    let hasEmbeddedContent = false;
    let newContentState = contentState;

    const newState = EditorState.push(editorState, newContentState, 'apply-entity');
    setEditorState(newState);
    //  const htmlContent = stateToHTML(contentState)
    const htmlContent = draftToHtml(convertToRaw(editorState.getCurrentContent())); // Convert the whole content, not just embedded links
    setValue('articleDescription', htmlContent);
  };

  const embedCallback = (url: any) => {
    if (url.indexOf('youtu.be/') >= 0) {
      // Extract the video ID from the URL
      const videoId = url.match(/youtu\.be\/([^?]+)/);
      if (videoId) {
        // Construct the new embed URL for youtu.be format
        return `https://www.youtube.com/embed/${videoId[1]}`;
      }
    } else if (url.indexOf('youtube') >= 0) {
      // Convert the 'watch' URL to the 'embed' format for youtube.com
      url = url.replace('watch?v=', 'embed/');
      url = url.replace('/watch/', '/embed/');
      url = url.replace('youtu.be/', 'youtube.com/embed/');
    }
    // If the URL doesn't match either format, return the original URL
    return url;
  };

  const handlePhotoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setImgError('');
    const photo = event.target.files ? event.target.files[0] : null;
    if (!photo) {
      setCoverImageUrl(null);
      setImgError('Cover image is required');
      return;
    }
    if (photo && photo.size > imgSize.limitValue) {
      setImgError('We cannot upload this file, please try another.');
      return;
    }
    if (photo) {
      const fileType = photo.type.toLowerCase();
      if (fileType === 'image/jpeg' || fileType === 'image/jpg' || fileType === 'image/png') {
        handleImageCompression(photo)
          .then((compressedImage) => {
            if (compressedImage) {
              setCoverImageUrl(compressedImage);
            }
          })
          .catch((error) => {
            // console.error("Error", error);
          });
      } else {
        setImgError('Only JPG, JPEG and PNG files are allowed for the cover image.');
        return;
      }
    }
  };

  useMemo(() => {
    if (videoFile?.type?.startsWith('video/')) {
      setVideoSource(URL.createObjectURL(videoFile));
    } else if (defaultVideoUrl) {
      setVideoSource(defaultVideoUrl);
    } else {
      setVideoSource(videoUrl);
    }
  }, [videoFile, videoUrl, defaultVideoUrl]);

  useEffect(() => {
    if (watchArticleType === 'Text') {
      setAudioFile(null);
      setVideoFile(null);
      setAudioUrl(null);
      setVideoUrl(null);
      setDefaultAudioUrl(null);
      setDefaultVideoUrl(null);
    } else if (watchArticleType === 'Audio') {
      setVideoUrl(null);
      setVideoFile(null);
      setDefaultVideoUrl(null);
      setTextFileUrl(null);
      setTextFile(null);
    } else if (watchArticleType === 'Video') {
      setAudioUrl(null);
      setAudioFile(null);
      setDefaultAudioUrl(null);
      setTextFileUrl(null);
      setTextFile(null);
    }
  });

  // useEffect(() => {
  //   if ( !audioFile) {

  //     setAudioFile(audioVideoData);
  //   }
  // })

  // const cleanHtmlString = (htmlString: any) => {
  //   // Remove empty <figure> tags
  //   const cleanedHtml = htmlString?.replace(/<figure><img[^>]*><\/figure>/g, '');
  //   const withoutNbsp = cleanedHtml?.replace(/<figure>&nbsp;<\/figure>/g, '');
  //   // Remove <p> tags
  //   const strippedText = withoutNbsp?.replace(/<\/?p[^>]*>|<br\s*\/?>/g, '');
  //   return strippedText;
  // };

  const cleanHtmlString = (htmlString: any) => {
    // Remove empty <figure> tags
    const cleanedHtml = htmlString.replace(/<figure>&nbsp;<\/figure>/g, '');

    // Remove <p> tags
    const strippedText = cleanedHtml.replace(/<\/?p[^>]*>|<br\s*\/?>/g, '');

    return strippedText;
  };

  const handelEditArticle = () => {
    setAction('Edit');
    setAudioError('');
    setVideoError('');
    setImgError('');
    setVideoFile(null);
    try {
      let data = singleListData;
      for (const field in data) {
        setValue(field, data[field]);
      }
      const { articleDescription, coverImageUrl, fileUrl, embeddedLinks, articleViewableTo, articleViewableUserType } = data;
      // setAudioVideoData(data.fileUrl);

      if (data.fileUrl.endsWith('.mp3')) {
        setAudioUrl(data.fileUrl);
      } else if (data.fileUrl.endsWith('.mp4')) {
        setVideoUrl(data.fileUrl);
      } else if (fileUrl.startsWith('https://www.youtube.com/embed/')) {
        setVideoUrl(data.fileUrl);
      } else if (data.fileUrl.endsWith('.webm || WEBM')) {
        setVideoUrl(data.fileUrl);
      } else {
        setTextFileUrl(data.fileUrl);
      }

      setUrlName(fileUrl);
      if (/\.(mp4|webm|ogg|ogv)$/i.test(fileUrl)) {
        if (watchArticleType === 'Video') {
          setVideoFile(fileUrl);
        }
        setEditVideoUrl(fileUrl);
      }
      if (/\.(mp3|wav|ogg)$/i.test(fileUrl)) {
        if (watchArticleType === 'Audio') {
          setAudioFile(fileUrl);
        }
        setEditAudioUrl(fileUrl);
      }
      setValue('articleDescription', articleDescription);
      setValue('articleViewableUserType ', articleViewableUserType);
      setValue('articleViewableTo ', articleViewableTo);

      setValue('coverImg', coverImageUrl);
      setIsPublished(true);
      setEditCoverImg(coverImageUrl);
      setEmbedded(true);
      const { contentBlocks, entityMap } = htmlToDraft(articleDescription);
      const customEntityMap = { ...entityMap };

      const contentStateWithEntities = ContentState.createFromBlockArray(contentBlocks, entityMap);

      const editorState = EditorState.createWithContent(contentStateWithEntities);
      setEditorState(editorState);
    } catch (error) { }
  };
  useEffect(() => {
    if (action === 'Edit' && singleListData) {
      handelEditArticle();
    } else {
      reset();
    }
  }, [singleListData, action]);
  const handleRemoveImageFile = () => {
    setCoverImageUrl(null);
    const inputElement = document.getElementById('coverImgInput') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
    setEditCoverImg('');
  };
  const handleRemoveAudioFile = () => {
    setAudioFile(null);
    setEditAudioUrl(null);
    setAudioUrl(null);
    setDefaultAudioUrl(null);
  };
  const handleRemoveVideoFile = () => {
    setVideoFile(null);
    setEditVideoUrl(null);
    setVideoSource(null);
    setVideoUrl(null);
    setDefaultVideoUrl(null);
  };

  const [fileRemove, setFileRemove] = useState(false);
  const handleRemoveTextFileUrl = () => {
    setTextFile(null);
    setTextFileUrl(null);
    setFileRemove(true);
  };

  const validExtensions = ['.jpeg', '.png', '.jpg']; // for cover Image

  function getValidExtension(coverImageUrl: string) {
    const extension = validExtensions.find((extension) => coverImageUrl.endsWith(extension));
    return extension ? extension : '';
  }

  const onSubmit: SubmitHandler<FieldValues> = async (value) => {
    setAddArticlesLoaer(true);

    if (watchArticleType === 'Audio') {
      if (!audioFile && !audioUrl && !['mp3'].includes(defaultAudioUrl)) {
        setAudioError('Audio file is required for Audio type.');
        setAddArticlesLoaer(false);
        return;
      }
    }

    if (watchArticleType === 'Video') {
      if (!videoFile && !videoUrl && !videoSource && !['mp4'].includes(defaultVideoUrl)) {
        setVideoError('Video file is required for Video type.');
        setAddArticlesLoaer(false);
        return;
      }
    }

    if (!coverImageUrl && !editCoverImg) {
      setImgError('Cover image is required');
      setAddArticlesLoaer(false);
      return;
    }

    const formData = new FormData();
    formData.append('articleName', value.articleName);
    formData.append('type', value.type);
    formData.append('authorName', value.authorName);
    formData.append('topic', value.topic);
    if (coverImageUrl) {
      formData.append('coverImage', coverImageUrl);
    }
    if (editCoverImg) {
      formData.append('coverImage', editCoverImg);
    }
    formData.append('readTime', value.readTime);
    // formData.append('accessFor', value.accessFor);
    formData.append('articleViewableTo', value.articleViewableTo);
    formData.append(
      'articleViewableUserType',
      value.articleViewableUserType[0] === 'All members' ? ['All'] : value.articleViewableUserType
    );

    if (value.embeddedLinks) {
      formData.append('embeddedLinks', value.embeddedLinks);
    }
    // formData.append('embeddedLinks', value.embeddedLinks)
    if (value.articleDescription !== '<p>/<p>') {
      formData.append('articleDescription', value.articleDescription);
      setError('articleDescription', { message: undefined });
    } else {
      setError('articleDescription', { message: 'Article description is required' });
    }
    formData.append('isPublished', 'true');
    if (watchArticleType === 'Text') {
      if (!textFile && !fileRemove) {
        if (['application/pdf', 'text/csv'].includes(value.fileUrl)) {
          formData.append('file', value.fileUrl);
        }
      }
    }

    if (['Add', 'Edit'].includes(action)) {
      if (watchArticleType === 'Video') {
        if (videoFile?.type?.startsWith('video/')) {
          formData.append('file', videoFile);
        } else if (defaultVideoUrl) {
          formData.append('file', defaultVideoUrl);
        } else if (value.fileUrl) {
          formData.append('file', value.fileUrl);
        }
      }

      if (watchArticleType === 'Audio') {
        if (audioFile?.type?.startsWith('audio/')) {
          formData.append('file', audioFile);
        } else if (defaultAudioUrl) {
          formData.append('file', defaultAudioUrl);
        } else if (value.fileUrl) {
          formData.append('file', value.fileUrl);
        }
      }

      if (watchArticleType === 'Text') {
        if (['application/pdf', 'text/csv'].includes(textFile?.type)) {
          formData.append('file', textFile);
        }
      }
    }
    if (action === 'Add') {
      try {
        const response = await API.createArticle({
          data: formData,
          orgId: orgId,
          groupId: grpId,
          helpSettings: true,
        });
        if (response.status === 200 && response.data.message === 'Article Created Successfully') {
          setAddArticlesLoaer(false);
          dispatch(articleActions.addArticle(response.data.createArticleResponse));

          if (orgId && grpId) {
            dispatch(fetchAllArticles({ orgId: orgId, groupId: grpId, helpSettings: true, useCache: false }));
          }

          toast.success('Article created successfully');
          setOpenForm(false);
          setCoverImageUrl(null);
          reset();
        } else if (
          response.status === 200 &&
          response.data.message === "You don't have permission to access this API"
        ) {
          toast.error("You don't have permission to add an article");
          reset();
          setOpenForm(false);
        } else {
          throw new Error('Failed to create article');
        }
      } catch (error: any) {
        setAddArticlesLoaer(false);
        toast.error(_.get(error, 'response.data.message', 'Something went wrong, please try again'))
      }
    }


    if (action === 'Edit') {
      try {
        const response = await API.editArticle({
          data: formData,
          orgId: orgId,
          articleId: articleId,
          groupId: grpId,
          helpSettings: true
        });
        if (response.status === 200) {
          setAddArticlesLoaer(false);
          dispatch(articleActions.updateArticle(response.data.updatedArticle));
          if (orgId && grpId) {
            dispatch(fetchAllArticles({ orgId: orgId, groupId: grpId, helpSettings: true, useCache: false }));
          }
          toast.success('Article updated successfully');
          setOpenForm(false);
          setCoverImageUrl(null);
          reset();
        }
      } catch (error) {
        setAddArticlesLoaer(false);
        setOpenForm(false);
        toast.error('Something went wrong, please try again');
      }
    }
    formData.append('file', textFile);
    reset();
  };

  /** Display articles */

  const compressImage = (file: any, maxWidth: any, maxHeight: any, quality: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let { width } = img;
          let { height } = img;

          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }

          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          ctx?.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob: any) => {
              const compressedFile = new File([blob], file.name, {
                type: file.type,
                lastModified: file.lastModified
              });

              const compressedReader = new FileReader();
              compressedReader.onload = (compressedE: any) => {
                resolve(compressedE.target.result);
              };
              compressedReader.onerror = (error) => {
                reject(error);
              };
              compressedReader.readAsDataURL(compressedFile);
            },
            file.type,
            quality
          );
        };
        img.src = e.target.result;
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };

  const formData = new FormData();

  const uploadArticleDescriptionFile = async (file: File) => {
    formData.append('file', file);
    try {
      const result = await API.saveArticleDescriptionFiles(formData);
      const blobUrl = _.get(_.head(_.get(result, 'data.data')), 'Bloburl', '');
      return { data: { link: blobUrl } };
    } catch {
      return Error('Failed to upload');
    }
  };

  const imageUpload = async (file: any, maxWidth: any = 400, maxHeight: any = 400, quality: any = 1.0) => {
    if (!acceptedImages.includes(file.type)) {
      return { error: 'Image upload failed' };
    } else {
      try {
        if (file.size <= 1024 * 1024) {
          const result = await uploadArticleDescriptionFile(file);
          return result;
        } else {
          const reSizedFile = await handleImageCompression(file);
          if (reSizedFile) {
            const result = await uploadArticleDescriptionFile(reSizedFile);
            return result;
          }
        }

        // formData.append("file", file)
        // const result = await API.saveArticleDescriptionFiles(formData)
        // const test =  _.get(_.head(_.get(result,'data.data')),'Bloburl','');
        // const imageDataUrl = await handleImageCompression(file)
        // const tt =  await readAsDataURL(imageDataUrl)
        // return {data: {link: test}}
        // const imageDataUrl = await compressImage(file, maxWidth, maxHeight, quality);
      } catch (error) {
        // console.error('Image upload error:', error);
        return { error: 'Image upload failed' };
      }
    }
  };

  const handleUserTypes = (event: any, value: string[]) => {
    if (value?.length > 0) {
      if (value?.includes('All members')) {
        value = ['All members'];
      }
      setValue('articleViewableUserType', value);
      setError('articleViewableUserType', { message: undefined });
    } else {
      setValue('articleViewableUserType', []);
      setError('articleViewableUserType', { message: 'Select at least one User' });
    }
  };

  const chipSx = {
    '& .MuiChip-root': {
      backgroundColor: '#FDFDFD',
      color: '#0F0F0F',
      borderRadius: '20px',
      fontSize: 12,
      fontWeight: 400,
      '& .MuiChip-deleteIcon': { color: '#0F0F0F' }
    }
  };

  return (
    <Dialog
      open={openForm}
      disableEnforceFocus
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          bgcolor: '#0F0F0F',
          border: '1px solid #444444',
          borderRadius: 2,
          overflow: 'hidden',
          maxWidth: 760,
          width: '100%'
        }
      }}
    >
      <CommonModalHeader
        title={
          <Typography sx={{ color: '#FDFDFD', fontWeight: 700, fontSize: 18, fontFamily: 'Inter, sans-serif' }}>
            {action === 'Edit' ? 'Edit Content' : 'New Content Drop'}
          </Typography>
        }
        handleCloseModal={handleCloseArticleForm}
      />
      <DialogContent sx={{ p: '25px' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
            <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500, fontFamily: 'Inter, sans-serif', lineHeight: '20px' }}>
              Article Name *
            </Typography>
            <Controller
              name="articleName"
              control={control}
              render={({ field: { onChange, value } }) => (
                <UiInput
                  name="articleName"
                  value={value || ''}
                  id="articleName"
                  type="text"
                  placeholder="Article Name"
                  onChange={onChange}
                  error={checkError('articleName')}
                  helperText={getError('articleName')?.toString()}
                />
              )}
            />
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500, fontFamily: 'Inter, sans-serif', lineHeight: '20px' }}>
                  Article Type *
                </Typography>
                <Controller
                  name="type"
                  control={control}
                  rules={{ required: true }}
                  defaultValue={type}
                  render={({ field }) => (
                    <UiSelect
                      placeholder="Select"
                      value={field.value || ''}
                      onChange={(event) => field.onChange(event)}
                      options={[
                        { label: 'Text', value: 'Text' },
                        { label: 'Audio', value: 'Audio' },
                        { label: 'Video', value: 'Video' }
                      ]}
                      errorText={getError('type')?.toString()}
                    />
                  )}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500, fontFamily: 'Inter, sans-serif', lineHeight: '20px' }}>
                  Read Time *
                </Typography>
                <Controller
                  name="readTime"
                  control={control}
                  defaultValue={readTimeValue}
                  render={({ field }) => (
                    <UiSelect
                      placeholder="Select"
                      value={field.value || ''}
                      onChange={(event) => field.onChange(event)}
                      options={[
                        { label: '1 min', value: '1 min' },
                        { label: '2 mins', value: '2 mins' },
                        { label: '3 mins', value: '3 mins' },
                        { label: '4 mins', value: '4 mins' },
                        { label: '5 mins', value: '5 mins' },
                        { label: '10 mins', value: '10 mins' },
                        { label: '15 mins', value: '15 mins' },
                        { label: '15+ mins', value: '15+ mins' }
                      ]}
                      errorText={getError('readTime')?.toString()}
                    />
                  )}
                />
              </Box>
            </Grid>
          </Grid>

          <Box display="flex" alignItems="center" sx={{ my: 1.5 }}>
            {!editCoverImg && (
              <>
                <Box
                  sx={{
                    width: '100px',
                    height: '70px',
                    background: '#444444',
                    border: '1px solid #868686',
                    marginRight: '12px',
                    borderRadius: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    cursor: 'pointer'
                  }}
                >
                  <Controller
                    name="coverImg"
                    control={control}
                    render={({ field }) => (
                      <label>
                        <input
                          id="coverImgInput"
                          name={field.name}
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={(e) => {
                            if (e.target.files && e.target.files.length > 0) {
                              const file = e.target.files[0];
                              field.onChange(file);
                              handlePhotoChange(e);
                            }
                          }}
                        />
                        <CameraAltOutlinedIcon sx={{ color: !coverImageUrl && !_.head(coverImageUrl) ? '#868686' : '#FFFFFF' }} />
                        {coverImageUrl && (
                          <img
                            src={URL.createObjectURL(coverImageUrl)}
                            style={{
                              width: '100px',
                              height: '70px',
                              objectFit: 'cover',
                              borderRadius: '6px'
                            }}
                            loading="lazy"
                            alt=""
                          />
                        )}
                      </label>
                    )}
                  />
                </Box>
                <Box>
                  <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500 }}>Cover Image *</Typography>
                  <Typography fontSize="12px" fontWeight="500" color={'#868686'}>
                    *Only JPG, PNG, SVG, or GIF (max. 800x800 px)
                  </Typography>
                </Box>
              </>
            )}
            {editCoverImg && (
              <Box
                sx={{
                  width: '100px',
                  height: '70px',
                  margin: '0 20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 'none'
                }}
              >
                <img
                  src={editCoverImg}
                  style={{
                    objectFit: 'contain',
                    width: '100%',
                    height: '100%'
                  }}
                  loading="lazy"
                  alt=""
                />
              </Box>
            )}
            {editCoverImg && (
              <Box>
                <Typography
                  variant="subtitle2"
                  fontSize="10px"
                  color="error"
                  onClick={handleRemoveImageFile}
                  className="cursor-pointer"
                >
                  Remove
                </Typography>
              </Box>
            )}
          </Box>
          {imgError && <FormHelperText error>{imgError}</FormHelperText>}
            {!imgError && <FormHelperText error>{getError('coverImg')?.toString()}</FormHelperText>}

          {watchArticleType === 'Video' && (
            <Box>
              {!videoFile && !videoUrl && (
                <Box
                  sx={{
                    background: '#0F0F0F',
                    border: '1px dashed #868686',
                    borderRadius: '8px',
                    padding: '12px 32px 18px',
                    margin: '10px 0',
                    textAlign: 'center'
                  }}
                >
                  <UiInput
                    placeholder="Enter video URL"
                    value={defaultVideoUrl}
                    onChange={handleVideoUrlChange}
                    sx={{ mb: 1 }}
                  />
                  <input type="file" id="file" accept="video/mp4" onChange={handleFileChange} className="d-none" />
                  <IconButton>
                    <label htmlFor="file">
                      <img src={upload} alt="upload" width="25px" height="25px" />
                    </label>
                  </IconButton>
                  <Typography
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 500,
                      fontSize: '12px',
                      color: '#B6B6B6'
                    }}
                  >
                    <label htmlFor="file">
                      <span style={{ color: '#3D8BFD', fontSize: '14px', cursor: 'pointer' }}>Click to upload</span>
                    </label>
                    {' or drag '}
                    <br />
                    Article Video file (max size 100 MB)
                  </Typography>
                </Box>
              )}
              <Box display="flex" gap="8px" alignItems="center">
                <Box borderRadius="8px">
                  {videoFile && videoFile instanceof Blob && (
                    <video
                      style={{ borderRadius: '8px' }}
                      src={URL.createObjectURL(videoFile)}
                      width="320"
                      height="240"
                      controls
                    />
                  )}
                  {videoUrl && (
                    <iframe
                      style={{ borderRadius: '8px', objectFit: 'cover' }}
                      src={videoUrl}
                      width="280"
                      height="180"
                      title="Video preview"
                    />
                  )}
                </Box>
                <Box>
                  {videoFile && (
                    <Box>
                      <Box display="flex" gap="8px" alignItems="center">
                        <Typography variant="h6" sx={{ color: '#FDFDFD' }}>
                          Article Video
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          fontSize="10px"
                          color="error"
                          onClick={handleRemoveVideoFile}
                          className="cursor-pointer"
                        >
                          Remove
                        </Typography>
                      </Box>
                      <Typography fontSize="10px" fontWeight="600" color="#868686">
                        * Only Mp4 (max. 100 Mb)
                      </Typography>
                    </Box>
                  )}
                  {videoUrl && !videoFile && (
                    <Box>
                      <Box display="flex" gap="8px" alignItems="center">
                        <Typography variant="h6" sx={{ color: '#FDFDFD' }}>
                          Article Video
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          fontSize="10px"
                          color="error"
                          onClick={handleRemoveVideoFile}
                          className="cursor-pointer"
                        >
                          Remove
                        </Typography>
                      </Box>
                      <Typography fontSize="10px" fontWeight="600" color="#868686">
                        * Only Mp4 (max. 100 Mb)
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
              {videoError && <FormHelperText error>{videoError}</FormHelperText>}
            </Box>
          )}

          {watchArticleType === 'Audio' && (
            <Box>
              {!audioFile && !audioUrl && (
                <Box
                  sx={{
                    background: '#0F0F0F',
                    border: '1px dashed #868686',
                    borderRadius: '8px',
                    padding: '12px 32px 18px',
                    margin: '10px 0',
                    textAlign: 'center'
                  }}
                >
                  <UiInput
                    placeholder="Enter audio URL"
                    value={defaultAudioUrl}
                    onChange={handleAudioUrlChange}
                    sx={{ mb: 1 }}
                  />
                  <input type="file" id="audioFile" accept="audio/mp3" onChange={handleAudioFileChange} className="d-none" />
                  <IconButton>
                    <label htmlFor="audioFile">
                      <img
                        src={upload}
                        alt="upload"
                        style={{
                          padding: 0,
                          margin: 0,
                          width: '25px',
                          height: '25px'
                        }}
                      />
                    </label>
                  </IconButton>
                  <div
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 500,
                      fontSize: '12px',
                      color: '#B6B6B6'
                    }}
                  >
                    <label htmlFor="audioFile">
                      <span style={{ color: '#3D8BFD', fontSize: '14px' }}>Click to upload</span>
                    </label>
                    {' or drag '}
                    <br />
                    Article Audio File (max. 100 MB)
                  </div>
                </Box>
              )}

              <Box display="flex">
                <Box borderRadius="8px">
                  {audioFile?.type?.startsWith('audio/') ? (
                    <audio
                      style={{ borderRadius: '8px' }}
                      src={audioFile && URL.createObjectURL(audioFile)}
                      controls
                      preload="auto"
                    >
                      Your browser does not support the audio element.
                    </audio>
                  ) : audioUrl && audioUrl.endsWith('.mp3') ? (
                    <audio style={{ borderRadius: '8px' }} src={audioUrl} controls preload="auto">
                      Your browser does not support the audio element.
                    </audio>
                  ) : null}
                </Box>
                {(audioFile || audioUrl) && (
                  <Box ml={1} my="auto">
                    <IconButton onClick={handleRemoveAudioFile}>
                      <Close fontSize="small" color="error" />
                    </IconButton>
                  </Box>
                )}
              </Box>
              {audioError && <FormHelperText error>{audioError}</FormHelperText>}
            </Box>
          )}

          {watchArticleType === 'Text' && (
            <Box>
              {!textFile && !textFileUrl && (
                <Box
                  sx={{
                    background: '#0F0F0F',
                    border: '1px dashed #868686',
                    borderRadius: '8px',
                    padding: '12px 32px 18px',
                    margin: '10px 0',
                    textAlign: 'center'
                  }}
                >
                  <input
                    type="file"
                    id="textFile"
                    accept="application/pdf,.csv"
                    className="d-none"
                    onChange={handleTextFileChange}
                  />

                  <IconButton>
                    <label htmlFor="textFile">
                      <img
                        src={upload}
                        alt="upload"
                        style={{
                          padding: 0,
                          margin: 0,
                          width: '25px',
                          height: '25px'
                        }}
                      />
                    </label>
                  </IconButton>
                  <div
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 500,
                      fontSize: '12px',
                      color: '#B6B6B6'
                    }}
                  >
                    <label htmlFor="textFile">
                      <span style={{ color: '#3D8BFD', fontSize: '14px' }}>Click to upload</span>
                    </label>
                    {' or drag '}
                    <br />
                    Article Text File (max. 100 MB)
                  </div>
                </Box>
              )}
              <Box display="flex">
                <Box borderRadius="8px">{textFileUrl && <p style={{ color: '#FDFDFD' }}>{textFileUrl?.name}</p>}</Box>
                {(textFile || textFileUrl) && (
                  <Box
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 600,
                      fontSize: '14px',
                      color: '#FDFDFD',
                      mt: '10px',
                      mb: '10px',
                      ml: '1%',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1
                    }}
                  >
                    <span
                      onClick={() =>
                        textFileUrl?.includes('http')
                          ? window.open(textFileUrl, '_blank')
                          : blobTextFileUrl
                          ? window.open(blobTextFileUrl, '_blank')
                          : null
                      }
                      style={{
                        color: '#FDFDFD',
                        textDecorationLine: 'underline',
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6
                      }}
                    >
                      <FileOutlined /> {watchArticleType === 'Text' ? (textFile?.name ? textFile.name : filename) : ''}
                    </span>
                    <IconButton onClick={handleRemoveTextFileUrl}>
                      <Close fontSize="small" color="error" />
                    </IconButton>
                  </Box>
                )}
              </Box>
              {textFileError && (
                <FormHelperText color="error" className="text-danger">
                  {textFileError}
                </FormHelperText>
              )}
            </Box>
          )}

            <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500, fontFamily: 'Inter, sans-serif', lineHeight: '20px' }}>
                  Author Name *
                </Typography>
                <Controller
                  name="authorName"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <UiInput
                      name="authorName"
                      value={value || ''}
                      id="authorName"
                      type="text"
                      placeholder="Author Name"
                      onChange={onChange}
                      error={checkError('authorName')}
                      helperText={getError('authorName')?.toString()}
                    />
                  )}
                />
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500, fontFamily: 'Inter, sans-serif', lineHeight: '20px' }}>
                  Article Viewable To *
                </Typography>
                <Controller
                  name="articleViewableTo"
                  control={control}
                  render={({ field }) => (
                    <UiSelect
                      placeholder="Select"
                      value={getValues('articleViewableTo') || field.value || ''}
                      onChange={(event) => {
                        field.onChange(event);
                        validateTopicAndViewability();
                      }}
                      options={[
                        { label: 'All of Dosen', value: 'All of Dosen' },
                        { label: 'Organization-wide', value: 'Organization-wide' },
                        { label: 'Program only', value: 'Program only' }
                      ]}
                      errorText={getError('articleViewableTo')?.toString()}
                    />
                  )}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
            <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500, mb: 0.5, fontFamily: 'Inter, sans-serif', lineHeight: '20px' }}>
              Article Accessible To *
            </Typography>
              <Controller
                name="articleViewableUserType"
                control={control}
                defaultValue={[]} // Initialize with an empty array
                render={({ field: { value } }) => (
                  <Autocomplete
                    multiple
                    options={roleOptions}
                    getOptionLabel={(option) => _.startCase(roleNameFormatter(option, mentorRoleText, menteeRoleText))}
                    value={value}
                    id="articleAccessiableTo"
                    disableCloseOnSelect
                    getOptionDisabled={(option) =>
                      (value?.includes('All members') || value?.includes('Prefer not to say')) && option !== value[0]
                    }
                    onChange={handleUserTypes}
                    renderInput={(params) => (
                      <UiInput
                        {...params}
                        error={getError('articleViewableUserType') ? true : false}
                        fullWidth
                        placeholder="Article Accessible To"
                      />
                    )}
                    sx={{
                      ...chipSx,
                      '& .MuiOutlinedInput-root': {
                        background: 'rgba(0,0,0,0.70)',
                        color: '#FDFDFD',
                        borderRadius: '6px',
                        outline: '1px solid #868686',
                        '&:hover': { outlineColor: '#B4B4B4' },
                        '&.Mui-focused': { outlineColor: '#F79420' },
                        '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
                      }
                    }}
                  />
                )}
              />
              <FormHelperText error>
                {checkError('articleViewableUserType') && getError('articleViewableUserType')?.toString()}
              </FormHelperText>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500, mb: 0.5, fontFamily: 'Inter, sans-serif', lineHeight: '20px' }}>
                Topics *
              </Typography>
              <Controller
                name="topic"
                control={control}
                render={({ field }) => {
                  return (
                    <Autocomplete
                      id="topics"
                      size="small"
                      value={field.value || null}
                      onChange={(event, newValue) => {
                        setValue('topic', newValue);
                        errors['topic'] = undefined;
                        validateTopicAndViewability();
                      }}
                      options={TagList || []}
                      selectOnFocus
                      clearOnBlur
                      handleHomeEndKeys
                      disableCloseOnSelect
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          background: 'rgba(0,0,0,0.70)',
                          color: '#FDFDFD',
                          borderRadius: '6px',
                          outline: '1px solid #868686',
                          '&:hover': { outlineColor: '#B4B4B4' },
                          '&.Mui-focused': { outlineColor: '#F79420' },
                          '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
                        }
                      }}
                      renderInput={(params) => (
                        <UiInput
                          {...params}
                          placeholder="Select"
                          error={checkError('topic')}
                          helperText={getError('topic')?.toString()}
                        />
                      )}
                    />
                  );
                }}
              />
            </Grid>

            {editEmbedded && (
              <Grid item xs={12}>
                <Controller
                  name="embeddedLinks"
                  control={control}
                  render={({ field: { onChange, value } }) => {
                    return (
                      <Box>
                        {value ? (
                          <Box mb={1} sx={{ position: 'relative', width: 'fit-content' }}>
                            <Typography sx={{ color: '#FDFDFD', mb: 0.5 }}>Embedded Preview *</Typography>
                            <iframe
                              src={value}
                              title="Embedded Preview"
                              style={{ width: '200px', height: '200px', border: 'none' }}
                            />
                            <Box top={0} right={0} position="absolute">
                              <IconButton onClick={() => onChange('')}>
                                <Close fontSize="small" color="error" />
                              </IconButton>
                            </Box>
                          </Box>
                        ) : null}
                      </Box>
                    );
                  }}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500, mb: 0.5, fontFamily: 'Inter, sans-serif', lineHeight: '20px' }}>
                Article Description *
              </Typography>
              <Box sx={{ width: '100%' }}>
                <Controller
                  name="articleDescription"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <>
                      <Editor
                        editorStyle={{
                          margin: '0px',
                          padding: '8px 12px',
                          fontFamily: 'Inter, sans-serif',
                          background: 'rgba(0,0,0,0.7)',
                          color: '#FDFDFD',
                          minHeight: '140px'
                        }}
                        wrapperStyle={{
                          padding: 0,
                          border: '1px solid #868686',
                          borderRadius: '6px'
                        }}
                        toolbarStyle={toolBarStyle}
                        customBlockRenderFunc={blockRender}
                        customDecorators={decorator}
                        toolbar={{
                          options: ['inline', 'list', 'image', 'embedded', 'emoji', 'textAlign', 'colorPicker'],
                          inline: { options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace'] },
                          list: { options: ['unordered', 'ordered'] },
                          textAlign: { options: ['left', 'center', 'right', 'justify'] },
                          colorPicker: {
                            popupClassName: 'articletoolbar-modal'
                          },
                          image: {
                            popupClassName: 'articletoolbar-modal',
                            inputAccept: acceptedImages,
                            uploadCallback: imageUpload,
                            previewImage: true
                          },
                          embedded: {
                            popupClassName: 'articletoolbar-modal',
                            embedCallback: embedCallback
                          },
                          emoji: {
                            popupClassName: 'articletoolbar-modal'
                          }
                        }}
                        editorState={editorState}
                        onEditorStateChange={handleEditorStateChange}
                        placeholder="Write your article description here"
                        toolbarClassName="toolBarStyle toolBarStyleArticle"
                        wrapperClassName="wrapperClassName p-0 b-0"
                        editorClassName="editorSize helpEditorClass"
                      />

                      <FormHelperText color="error" className="text-danger">
                        {checkError('articleDescription') && getError('articleDescription')?.toString()}
                      </FormHelperText>
                    </>
                  )}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: '15px 20px', justifyContent: 'center' }}>
        <LoadingButton
          fullWidth
          variant="contained"
          loading={addArticlesLoader}
          onClick={handleSubmit(onSubmit)}
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '13px',
            fontWeight: 600,
            color: '#FDFDFD',
            background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
            borderRadius: '6px',
            width: '100%',
            maxWidth: 560,
            height: 48,
            textTransform: 'none',
            '&:hover': {
              background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
              boxShadow: 'none'
            }
          }}
        >
          {action === 'Edit' ? 'Save' : 'Add New Content'}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default HelpEdit;
